import { useCallback, useState } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { UDText } from 'ud-ui/components';
import UDButton from 'ud-ui/components/button';
import Modal from 'ud-ui/components/modal';

interface PreventNavigationModalProps {
  navigationTx?: {
    id: string;
    status: string;
  };
  nextLocation: string | number | null;
  targetPath: string | null;
  confirmNavigation: () => void;
  navigate: NavigateFunction;
  defaultPath?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export function usePreventNavigationModal(props: PreventNavigationModalProps) {
  const { navigationTx, nextLocation, targetPath, confirmNavigation, navigate, onConfirm, onCancel, defaultPath } = props;
  const [modalOpen, setModalOpen] = useState(false);
  // const { defaultOpen: openLeaveModal, close: closeLeaveModal, Modal: LeaveModal } = useModal();

  const openLeaveModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  const closeLeaveModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const handleCancel = useCallback(() => {
    closeLeaveModal();
    onCancel?.();
  }, [closeLeaveModal, onCancel]);

  const handleConfirmLeave = useCallback(() => {
    closeLeaveModal();
    onConfirm?.();

    setTimeout(() => {
      if (navigationTx) {
        confirmNavigation();
      } else if (nextLocation) {
        if (typeof nextLocation === 'number') {
          navigate(nextLocation);
        } else {
          navigate(nextLocation.toString());
        }
      } else if (targetPath) {
        navigate(targetPath);
      } else if (defaultPath) {
        navigate(defaultPath);
      }
    }, 0);
  }, [closeLeaveModal, onConfirm, navigationTx, nextLocation, targetPath, confirmNavigation, navigate, defaultPath]);

  const modal = useCallback(() => {
    return (
      <Modal show={modalOpen} onClose={handleCancel}>
        <Modal.Body>
          <UDText type="headline" className="mb-4">
            Несохраненные изменения
          </UDText>
          <UDText type="body-text">У вас есть несохраненные изменения.</UDText>
          <UDText type="body-text">Вы уверены, что хотите покинуть страницу?</UDText>
        </Modal.Body>
        <Modal.Footer>
          <UDButton variant="secondary" onClick={handleCancel} stretch>
            Отмена
          </UDButton>
          <UDButton variant="primary" onClick={handleConfirmLeave} stretch>
            Покинуть
          </UDButton>
        </Modal.Footer>
      </Modal>
    );
  }, [handleCancel, handleConfirmLeave, modalOpen]);

  return { openLeaveModal, closeLeaveModal, Modal: modal };
}
